import { downloadAccess, } from '../types'
import HttpService from '../../services/HttpService'

export const getDownloadAccess = () => {
  return async dispatch => {
    
    dispatch({ type: downloadAccess.GET_DOWNLOAD_ACCESS_ERROR, })

    const tokenId = "user-token"
    const http = new HttpService()
    await http.getData(
      '/users/temporary-resources',
      tokenId,
    )
      .then(res => {
        dispatch({
          payload: res.data.data,
          type: downloadAccess.GET_DOWNLOAD_ACCESS_SUCCESS,
        })
      })
      .catch(err => {
        let message
        if ("ERR_NETWORK" === err.code) {
          message = "Server unavailable."
        } else if (err.response?.data?.message) {
          message = err.response.data.message
        } else {
          message = "Something went wrong. Please come back later."
        }
        dispatch({ 
          type: downloadAccess.GET_DOWNLOAD_ACCESS_ERROR, 
          payload: message,
        })
      })
  }
}